import { Component, Input } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';

@Component({
    selector: 'app-conv-heatmap-chart',
    templateUrl: './conv-heatmap-chart.component.html',
    styleUrl: './conv-heatmap-chart.component.scss',
    standalone: false
})
export class ConvHeatmapChartComponent {
	@Input() rgbData: any[] = [];
	@Input() blinksData: any[] = [];
	@Input() voiceHeatMapData: any[] = [];
	@Input() leaksData: any[] = [];
	@Input() globalData: any[] = [];
	@Input() patternGlobalData: any[] = [];
	
	// options
	legend = false;
	animations = false;
	xAxis = true;
	yAxis = false;
	showYAxisLabel = false;
	showXAxisLabel = true;
	min = 0;
	max = 100;
	colorScheme: string | Color = {
		name: 'myScheme',
		selectable: true,
		group: ScaleType.Ordinal,
		domain: ['transparent', '#15A607', '#F1D50A', '#F1960A', '#F11C0A'],
	};

	chartData: any[] = [];

	series = [
		{ name: 'Cognitive', value: true },
		{ name: 'Emotion', value: true },
		{ name: 'Engagment', value: true },
		{ name: 'Voice', value: true },
		{ name: 'Leaks', value: true },
		// { name: 'Patterns', value: true }
	]

	lastCog = 0;
	lastEmo = 0;
	lastBlinks = 0;
	lastleaks = [];
	lastVoice = 0;
	lastGlobal = 0;
	lastPattern = 0;

	ready = false;

	showHeatmap() {
		for (let index = 0; index < this.series.length; index++) {
			this.series[index].value = this.isDataSuccessful(this.series[index].name);
		}

		this.ready = true;
		this.calculateHeatMapData(20);
	}

	calculateHeatMapData(currentTime: number) {
		const start = currentTime - 20;
		const dataChart = [];

		for (let index = start; index <= currentTime; index++) {
			const time = this.convertToTimerFormat(index);

			let cog;
			let emo;
			let blinks;
			let voice;
			let leaks;
			let global;
			let pattern;

			if (this.rgbData) {
				if (this.rgbData.length > 0) {
					if (index < this.rgbData.length) {
						cog = +(this.rgbData[index].cognitive);
						emo = +(this.rgbData[index].emotional);
			
						this.lastCog = cog;
						this.lastEmo = emo;
					} else {
						cog = this.lastCog;
						emo = this.lastEmo;
					}
				} else {
					cog = this.lastCog;
					emo = this.lastEmo;
				}
			} else {
				cog = this.lastCog;
				emo = this.lastEmo;
			}

			if (this.blinksData) {
				if (this.blinksData.length > 0) {
					if (index < this.blinksData.length) {
						blinks = +this.blinksData[index].blinks.toFixed(2);
						this.lastBlinks = blinks;
					} else {
						blinks = this.lastBlinks;
					}
				} else {
					blinks = this.lastBlinks;
				}
			} else {
				blinks = this.lastBlinks;
			}

			if (this.voiceHeatMapData) {
				if (this.voiceHeatMapData.length > 0) {
					if (index < this.voiceHeatMapData.length) {
						voice = +this.voiceHeatMapData[index].value.toFixed(2);
						this.lastVoice = voice;
					} else {
						voice = this.lastVoice;
					}
				} else {
					voice = this.lastVoice;
				}
			} else {
				voice = this.lastVoice;
			}

			if (this.leaksData) {
				if (this.leaksData.length > 0) {
					if (index < this.leaksData.length) {
						leaks = this.leaksData[index];
						this.lastleaks = leaks;
					} else {
						leaks = this.lastleaks;
					}
				} else {
					leaks = this.lastleaks;
				}
			} else {
				leaks = this.lastleaks;
			}

			if (this.patternGlobalData) {
				if (this.patternGlobalData.length > 0) {
					if (index < this.patternGlobalData.length) {
						pattern = +this.patternGlobalData[index].toFixed(0);
						this.lastPattern = pattern;
					} else {
						pattern = this.lastPattern;
					}
				} else {
					pattern = this.lastPattern;
				}
			} else {
				pattern = this.lastPattern;
			}

			const calcLeaks = this.calculateLeaksValue(leaks.length);

			const data = {
				name: time,
				series: [
					{ name: 'Cognitive', value: cog, original: cog },
					{ name: 'Emotion', value: emo, original: emo },
					{ name: 'Engagment', value: blinks, original: blinks },
					{ name: 'Voice', value: voice, original: voice },
					{ name: 'Leaks', value: calcLeaks, original: leaks },
					// { name: 'Patterns', value: pattern, original: pattern }
				]
			};

			dataChart.push(data);
		}

		this.chartData = [...dataChart];

		if (!this.ready) {
			this.ready = true;
		}
	}

	isDataSuccessful(value: string): boolean {
		switch (value) {
			case 'Cognitive':
				return (this.rgbData ? this.rgbData.length > 0 : false);	
			case 'Emotion':
				return (this.rgbData ? this.rgbData.length > 0 : false);	
			case 'Engagment':
				return (this.blinksData ? this.blinksData.length > 0 : false);	
			case 'Voice':
				return (this.voiceHeatMapData ? this.voiceHeatMapData.length > 0 : false);	
			case 'Leaks':
				return (this.leaksData ? this.leaksData.length > 0 : false);	
			case 'Patterns':
				return (this.patternGlobalData ? this.patternGlobalData.length > 0 : false);	
			default:
				return false;
		}
	}

	tooltipText(data: any): string {
		const cell = JSON.parse(JSON.stringify(data)).cell;

		let spanContent;

		if (Array.isArray(cell.original)) {
			const listItems = cell.original.map((item: any) => `<li>${item}</li>`).join('');
			spanContent = `<ol>${listItems}</ol>`;
		} else {
			spanContent = cell.original;
		}

		const span = `<span>${spanContent}</span>`;

		const tool = `
			<div class="p-1 fs-16">
				${cell.series} - ${cell.name}
				<hr class="m-0">
				${span}
			</div>
		`;

		return tool;
	}

	updateHeatmap(currentTime: number) {
		for (let index = 0; index < this.series.length; index++) {
			this.series[index].value = this.isDataSuccessful(this.series[index].name);
		}
		
		if (currentTime > 20) {
			this.calculateHeatMapData(currentTime);
		} else {
			this.calculateHeatMapData(20);
		}
	}

	calculateLeaksValue(value: number) {
		if (value === 1) {
			return 25;
		}

		if (value === 2) {
			return 50;
		}
		
		if (value === 3) {
			return 75;
		}

		if (value > 3) {
			return 100;
		}

		return 0;
	}

	convertToTimerFormat(seconds: number) {
		if (seconds < 3600) {
			// Display "mm:ss" format for the first 60 minutes
			const minutes = Math.floor(seconds / 60);
			const formattedSeconds = (seconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			return `${formattedMinutes}:${formattedSeconds}`;
		} else {
			// After 60 minutes, switch to "hh:mm:ss" format
			const hours = Math.floor(seconds / 3600);
			const remainingSeconds = seconds % 3600;
			const minutes = Math.floor(remainingSeconds / 60);
			const formattedSeconds = (remainingSeconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			const formattedHours = hours.toString().padStart(2, "0");
			return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
		}
	}
}
